import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractBaseApiService} from '@shared/services/abstract-base-api.service';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractApiService extends AbstractBaseApiService {

  protected _httpClient: HttpClient;

  constructor() {
    super();
    this._httpClient = inject(HttpClient);
  }

}
